<template>
  <main>
    <Trail />
    <Hero :program="program" />

    <ProgramList />
    <ServiceList />
    <InformationList />
    <PlatformList />
  </main>
</template>

<script>
import programs from "@/data.js";
import Hero from "@/components/home/Hero";
import Trail from "@/components/common/Trail";
import ProgramList from "@/components/home/ProgramList";
import ServiceList from "@/components/home/ServiceList";
import InformationList from "@/components/home/InformationList";
import PlatformList from "@/components/home/PlatformList";

export default {
  components: {
    Hero,
    Trail,
    ProgramList,
    ServiceList,
    InformationList,
    PlatformList
  },
  setup() {
    const program = programs[process.env.VUE_APP_PREFIX];
    return {
      program
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.trail {
  margin-bottom: 0;
}
</style>
